import React from "react";

const Footer = () => (
  <footer className="page-footer">
    <div className="footer-container">
      <div className="footer-left">
        <p>&copy; 2026 SalonTechPro. All rights reserved.</p>
      </div>
      <div className="footer-center">
        <a href="#privacy-policy">Privacy Policy</a>
        <span className="divider">|</span>
        <a href="#terms">Terms of Service</a>
        <span className="divider">|</span>
        <a href="#contact">Contact Us</a>
      </div>
      <div className="footer-right">
        <span>Version 1.0</span>
      </div>
    </div>
  </footer>
);

export default Footer;
